import * as React from 'react'
import createSvgIcon from '@material-ui/core/utils/createSvgIcon'

export default createSvgIcon(
  /*#__PURE__*/ React.createElement(
    React.Fragment,
    null,
    /*#__PURE__*/ React.createElement('path', {
      d: 'M5.5 1.5c-2.21 0 -4 3.134 -4 7s1.79 7 4 7 4 -3.134 4 -7 -1.79 -7 -4 -7Zm0 0H18c2.21 0 4 3.134 4 7 0 1.455 0 2.116 -0.577 3.715 -0.552 1.529 -0.982 3.132 -0.768 4.743 0.36 2.714 1.27 4.263 1.845 5v0.542h-12s-1.8 -1.44 -2.345 -5.542c-0.214 -1.611 0.216 -3.214 0.768 -4.743M8.965 12H12m2 0h3m2 0h2.5m-16 -5.5v4',
      stroke: 'currentColor',
      fill: 'fill',
      strokeWidth: '2',
    }),
  ),
  'Ver',
)
